import { Controller } from '@hotwired/stimulus';
import { onLCP, onTTFB } from 'web-vitals';

let started = false;

export class WebVitalsController extends Controller {
  static values = {
    pageType: String,
    step: String,
    url: String,
  };

  connect() {
    if (started) {
      return;
    }

    started = true;
    this.metrics = [];

    onLCP(this.queue);
    onTTFB(this.queue);

    addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        this.flush();
      }
    });
    addEventListener('pagehide', this.flush);
  }

  queue = metric => {
    this.metrics.push({
      name: metric.name,
      navigation_type: metric.navigationType,
      value: metric.value,
    });
  };

  flush = () => {
    if (this.metrics.length === 0) {
      return;
    }

    const body = JSON.stringify({
      metrics: this.metrics.splice(0),
      page_type: this.pageTypeValue,
      step: this.stepValue,
    });

    navigator.sendBeacon(this.urlValue, new Blob([body], { type: 'application/json' }));
  };
}
